import { fetchAllTags } from './contentful'

export const fetchTags = (callback) => fetchAllTags(callback)
